/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactLieuGridDto } from './ContactLieuGridDto';
import {
    ContactLieuGridDtoFromJSON,
    ContactLieuGridDtoFromJSONTyped,
    ContactLieuGridDtoToJSON,
} from './ContactLieuGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface ContactLieuGridDtoPaginatedResults
 */
export interface ContactLieuGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ContactLieuGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ContactLieuGridDto>}
     * @memberof ContactLieuGridDtoPaginatedResults
     */
    results?: Array<ContactLieuGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ContactLieuGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ContactLieuGridDtoPaginatedResults interface.
 */
export function instanceOfContactLieuGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContactLieuGridDtoPaginatedResultsFromJSON(json: any): ContactLieuGridDtoPaginatedResults {
    return ContactLieuGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ContactLieuGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactLieuGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ContactLieuGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ContactLieuGridDtoPaginatedResultsToJSON(value?: ContactLieuGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ContactLieuGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

